<template>
  <div class="documentation-list-loader">
    <b-spinner class="loader" type="grow" small />
  </div>
</template>

<script setup lang="ts">
// No props needed for this simple loader component
</script>

<style lang="scss" scoped>
.documentation-list-loader {
  display: flex;
  justify-content: center;
  padding: 2rem;
}
</style>
